import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { wreathe } from '../../asset/images';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { IContestAward, ITopUser, IUserSummary } from '../../types/global/helper';
import { IUserProfile } from '../../redux/user/actions';
import { ThspianAvatar } from '../Avatar/ThspianAvatar';

interface IWreathe {
    text?: string | number;
    imageStyle?: React.CSSProperties;
    textStyle?: React.CSSProperties;
    withImage?: boolean;
    contestAward?: IContestAward;
    mode?: 'dark' | 'light';
    onWreatheClick?: (user?: IUserSummary | ITopUser | IUserProfile | undefined) => void;
}

const WreatheWrapper = styled(Box, {
    shouldForwardProp: prop => prop !== 'mode',
})<{ mode: 'dark' | 'light' }>(({ theme, mode }) => ({
    backgroundImage: `url(${wreathe})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '12rem',
    width: '12rem',
    position: 'relative',
    filter: mode === 'dark' ? 'brightness(0) invert(1)' : 'none',
    [theme.breakpoints.down('sm')]: {
        height: '7rem',
        width: '7rem',
    },
}));

const Wreathe: React.FC<IWreathe> = ({
    text,
    imageStyle,
    textStyle,
    withImage,
    contestAward,
    onWreatheClick,
    mode = 'light', // default to light if not provided
}) => {
    const user = contestAward?.person_awarded;

    return (
        <Box>
            <WreatheWrapper mode={mode} sx={imageStyle}>
                {withImage && user ? (
                    <ThspianAvatar user={contestAward?.person_awarded} enableDefaultNavigation size="xLarge" />
                ) : (
                    <Typography
                        variant="body1"
                        sx={{
                            color: mode === 'dark' ? '#FFFFFF' : '#000000',
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                            fontSize: 16,
                            ...textStyle,
                        }}>
                        {text}
                    </Typography>
                )}
            </WreatheWrapper>
        </Box>
    );
};

export { Wreathe };
